module.exports = "data:image/gif;base64,R0lGODlhDwAPANUAAChf/1eD/wBJ93qf/wBU5gBS1gBFswA7nUeN/32v/wBPwAJl/xZ0/yiB/06V/wBGpTuP/0qY/1ie/1qg/wBXwiyJ/zGN/zSN/wJ6/xWG/xyG/ymP/zOS/zeW/z+a/0Cb/1Ol/1mn/2uw/3y6/wA4cwSA/xiI/2Kv/2ez/3u7/wB99ABx3RmP/1et/2S1/wCA7wB32oHG/wBgqf///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAADMALAAAAAAPAA8AAAZfwJlwSCwaj8gZKzkbzAIvTGNmKTpmrdhshBGWZh0iJzMUCWWmogLEcM1QM8FolSQ9RsiFUBNZwYQTEkUUBkIhMwgPRQkFG0MRQh8VBEUXWiqKMwdJADMnHkxCKRChoUEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/frozen.gif
// module id = HZMS
// module chunks = 1